import { observer } from 'mobx-react-lite'
import { type FC } from 'react'
import { ZIndex } from 'shared/constants/zIndex'
import { type AddPaymentMethodStore } from 'entities/Billing/ui/AddPaymentMethodModal'
import { CardFormFields } from 'pages/settings/ui/BillingPlan'
import styles from './styles.module.scss'

type IAddPaymentMethodContentProps = {
  addPaymentMethodStore: AddPaymentMethodStore
}

export const AddPaymentMethodContent: FC<IAddPaymentMethodContentProps> = observer(
  ({ addPaymentMethodStore }) => {
    const {
      nameError,
      cardError,
      apiError,
      name,
      setName,
      onChangeCard,
      setOnSubmit,
      clearCardError,
      isPrimary,
      setIsPrimary,
    } = addPaymentMethodStore

    return (
      <CardFormFields
        name={name}
        setName={setName}
        nameError={nameError}
        cardError={cardError}
        apiError={apiError}
        onChangeCard={onChangeCard}
        setOnSubmit={setOnSubmit}
        clearCardError={clearCardError}
        primaryCheckbox={{
          checked: isPrimary,
          onChecked: () => setIsPrimary(!isPrimary),
          label: 'Set as primary payment method',
          className: styles.primaryCheckbox,
          questionTooltipProps: {
            label: 'Use this card as your main payment method for all transactions',
            width: 238,
            className: styles.primaryTooltip,
            zIndex: ZIndex.OVERLAY_TOP_130,
          },
        }}
      />
    )
  }
)
